<template>
	<div class="horizontal-panel">
		<div v-if="showLeft" class="horizontal-panel-left">
			<slot name="left" />
		</div>
		<div class="horizontal-panel-content">
			<slot />
		</div>
		<div :class="{hidden: !showRightPanel}" class="horizontal-panel-right">
			<transition name="slide" mode="in-out" >
				<div v-if="showRight && showRightPanel" class="horizontal-panel-right-inner">
					<slot name="right" />
				</div>
			</transition>
		</div>
	</div>
</template>

<script>
export default {
	name: 'THorizontalPanel',
	props: { showRightPanel: Boolean, },
	computed: {
		showLeft() {
			return Boolean(this.$slots['left']);
		},
		showRight() {
			return Boolean(this.$slots['right']);
		}
	}
};
</script>

<style lang="scss" scoped>
.horizontal-panel {
	display: flex;
}

.horizontal-panel, .horizontal-panel-left, .horizontal-panel-right, .horizontal-panel-right-inner{
	height: 100%;
}

.horizontal-panel-left {
	max-width: 360px;
	box-shadow: 4px 0 2px -2px rgba(0, 0, 0, 0.1);
	z-index: 4;
}

.horizontal-panel-right {
	position: relative;
	width: auto;
	max-width: 660px;
	z-index: 3;
	&.hidden {
		width: 0px;
	}
}

.horizontal-panel-right-inner {
	transform: translate(0px);
	box-shadow: -4px 0 2px -2px rgba(0, 0, 0, 0.1);
}

.horizontal-panel-content {
	flex:1;
	height: 100%;
	width: 100%;
	position: relative;
}

.slide-enter-active {
	position: absolute;
	top: 0;
	right: 0;
	transition: transform .2s ease-out;
}

.slide-leave-active {
	position: absolute;
	top: 0;
	right: 0;
	transition: transform .2s ease-in;
}

.slide-enter, .slide-leave-to {
	transform: translateX(100%);
}
</style>
